import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-camera',
  templateUrl: './icon-camera.component.html',
  styleUrls: ['./icon-camera.component.scss'],
})
export class IconCameraComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
